/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactPersonDetailsDto } from './contactPersonDetailsDto';
import { AttachmentReferenceDto } from './attachmentReferenceDto';


export interface TenantMergeDto { 
    id?: string;
    name?: string;
    description?: string;
    type?: TenantMergeDto.TypeEnum;
    contractDate?: string;
    identificationNumber?: string;
    email?: string;
    phone?: string;
    tenantType: TenantMergeDto.TenantTypeEnum;
    paymentAddressId?: string;
    color?: string;
    checkpointIds?: Array<string>;
    pin?: string;
    smallLogoReference?: AttachmentReferenceDto;
    largeLogoReference?: AttachmentReferenceDto;
    homePage?: string;
    companyRegisterNumber?: string;
    iban?: string;
    bic?: string;
    court?: string;
    worksWithOenorm?: boolean;
    signatureReference?: AttachmentReferenceDto;
    certificateTitle?: string;
    signatureName?: string;
    longListTitle?: string;
    nameAddition?: string;
    contactPersonId?: string;
    embeddedContactPerson?: ContactPersonDetailsDto;
    restrictedToAssignedExternalTenants?: boolean;
    corporateGroupId?: string;
    catalogSourceTenantId?: string;
    clearCatalogSourceTenant?: boolean;
    hiddenInspectionPdfTypes?: Set<TenantMergeDto.HiddenInspectionPdfTypesEnum>;
    emailRequiredInspectionPdfTypes?: Set<TenantMergeDto.EmailRequiredInspectionPdfTypesEnum>;
    horaPassInspectionPdfTypes?: Set<TenantMergeDto.HoraPassInspectionPdfTypesEnum>;
    allowIncompleteInspectionUpload?: boolean;
    usesRiskAssessmentByDefault?: boolean;
}
export namespace TenantMergeDto {
    export type TypeEnum = 'Internal' | 'External' | 'Contractor';
    export const TypeEnum = {
        Internal: 'Internal' as TypeEnum,
        External: 'External' as TypeEnum,
        Contractor: 'Contractor' as TypeEnum
    };
    export type TenantTypeEnum = 'Internal' | 'External' | 'Contractor';
    export const TenantTypeEnum = {
        Internal: 'Internal' as TenantTypeEnum,
        External: 'External' as TenantTypeEnum,
        Contractor: 'Contractor' as TenantTypeEnum
    };
    export type HiddenInspectionPdfTypesEnum = 'SHORTLIST' | 'LONGLIST' | 'COVERSHEET' | 'BUILDING_EQUIPMENTS' | 'CERTIFICATE_SHEET' | 'REPAIR_TASK_SHORTLIST' | 'BUILDING_EQUIPMENTS_SCHLOSS' | 'CERTIFICATE_SHEET_SCHLOSS' | 'OBJECT_SAFETY_REPORT' | 'SCHADSTELLENPLAN' | 'OBJECT_SAFETY_LIST';
    export const HiddenInspectionPdfTypesEnum = {
        Shortlist: 'SHORTLIST' as HiddenInspectionPdfTypesEnum,
        Longlist: 'LONGLIST' as HiddenInspectionPdfTypesEnum,
        Coversheet: 'COVERSHEET' as HiddenInspectionPdfTypesEnum,
        BuildingEquipments: 'BUILDING_EQUIPMENTS' as HiddenInspectionPdfTypesEnum,
        CertificateSheet: 'CERTIFICATE_SHEET' as HiddenInspectionPdfTypesEnum,
        RepairTaskShortlist: 'REPAIR_TASK_SHORTLIST' as HiddenInspectionPdfTypesEnum,
        BuildingEquipmentsSchloss: 'BUILDING_EQUIPMENTS_SCHLOSS' as HiddenInspectionPdfTypesEnum,
        CertificateSheetSchloss: 'CERTIFICATE_SHEET_SCHLOSS' as HiddenInspectionPdfTypesEnum,
        ObjectSafetyReport: 'OBJECT_SAFETY_REPORT' as HiddenInspectionPdfTypesEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as HiddenInspectionPdfTypesEnum,
        ObjectSafetyList: 'OBJECT_SAFETY_LIST' as HiddenInspectionPdfTypesEnum
    };
    export type EmailRequiredInspectionPdfTypesEnum = 'SHORTLIST' | 'LONGLIST' | 'COVERSHEET' | 'BUILDING_EQUIPMENTS' | 'CERTIFICATE_SHEET' | 'REPAIR_TASK_SHORTLIST' | 'BUILDING_EQUIPMENTS_SCHLOSS' | 'CERTIFICATE_SHEET_SCHLOSS' | 'OBJECT_SAFETY_REPORT' | 'SCHADSTELLENPLAN' | 'OBJECT_SAFETY_LIST';
    export const EmailRequiredInspectionPdfTypesEnum = {
        Shortlist: 'SHORTLIST' as EmailRequiredInspectionPdfTypesEnum,
        Longlist: 'LONGLIST' as EmailRequiredInspectionPdfTypesEnum,
        Coversheet: 'COVERSHEET' as EmailRequiredInspectionPdfTypesEnum,
        BuildingEquipments: 'BUILDING_EQUIPMENTS' as EmailRequiredInspectionPdfTypesEnum,
        CertificateSheet: 'CERTIFICATE_SHEET' as EmailRequiredInspectionPdfTypesEnum,
        RepairTaskShortlist: 'REPAIR_TASK_SHORTLIST' as EmailRequiredInspectionPdfTypesEnum,
        BuildingEquipmentsSchloss: 'BUILDING_EQUIPMENTS_SCHLOSS' as EmailRequiredInspectionPdfTypesEnum,
        CertificateSheetSchloss: 'CERTIFICATE_SHEET_SCHLOSS' as EmailRequiredInspectionPdfTypesEnum,
        ObjectSafetyReport: 'OBJECT_SAFETY_REPORT' as EmailRequiredInspectionPdfTypesEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as EmailRequiredInspectionPdfTypesEnum,
        ObjectSafetyList: 'OBJECT_SAFETY_LIST' as EmailRequiredInspectionPdfTypesEnum
    };
    export type HoraPassInspectionPdfTypesEnum = 'SHORTLIST' | 'LONGLIST' | 'COVERSHEET' | 'BUILDING_EQUIPMENTS' | 'CERTIFICATE_SHEET' | 'REPAIR_TASK_SHORTLIST' | 'BUILDING_EQUIPMENTS_SCHLOSS' | 'CERTIFICATE_SHEET_SCHLOSS' | 'OBJECT_SAFETY_REPORT' | 'SCHADSTELLENPLAN' | 'OBJECT_SAFETY_LIST';
    export const HoraPassInspectionPdfTypesEnum = {
        Shortlist: 'SHORTLIST' as HoraPassInspectionPdfTypesEnum,
        Longlist: 'LONGLIST' as HoraPassInspectionPdfTypesEnum,
        Coversheet: 'COVERSHEET' as HoraPassInspectionPdfTypesEnum,
        BuildingEquipments: 'BUILDING_EQUIPMENTS' as HoraPassInspectionPdfTypesEnum,
        CertificateSheet: 'CERTIFICATE_SHEET' as HoraPassInspectionPdfTypesEnum,
        RepairTaskShortlist: 'REPAIR_TASK_SHORTLIST' as HoraPassInspectionPdfTypesEnum,
        BuildingEquipmentsSchloss: 'BUILDING_EQUIPMENTS_SCHLOSS' as HoraPassInspectionPdfTypesEnum,
        CertificateSheetSchloss: 'CERTIFICATE_SHEET_SCHLOSS' as HoraPassInspectionPdfTypesEnum,
        ObjectSafetyReport: 'OBJECT_SAFETY_REPORT' as HoraPassInspectionPdfTypesEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as HoraPassInspectionPdfTypesEnum,
        ObjectSafetyList: 'OBJECT_SAFETY_LIST' as HoraPassInspectionPdfTypesEnum
    };
}


